import React, { Component } from 'react';
import QRCode from "react-qr-code";
import downloadjs from 'downloadjs';
import html2canvas from 'html2canvas';
import { Box, IconButton, Typography } from '@material-ui/core';
import { CloudDownloadRounded } from '@material-ui/icons';
import PopUp from '../../../../commonModules/interface/PopUp';

class GenerateQrCode extends Component {
    state = { 
        infos: "",
    }
    // componentDidMount = () => {
    //     let infos = ""
    //     if (!isEmpty(this.props.product)) {
    //         infos = `Aquisition : ${new Date(this.props.product.product_date).toLocaleDateString("fr-FR")}
    //             ID : ${this.props.product.product_id}
    //             Nom : ${this.props.product.product_name}
    //         `
    //     }        
    // }

    onImageDownload = async () => {
        const canvas = await html2canvas(document.getElementById("section-to-print"));
        const dataURL = canvas.toDataURL('image/png');
        downloadjs(dataURL, `${this.props.qrRef || this.props.product.product_ref}.png`, 'image/png');
    };
    
    render() {
        console.log('===============PROPS QR CODE=====================');
        console.log(this.props);
        console.log('====================================');
        return (
            <PopUp
                title={this.props.title || this.props.product.name}
                close={this.props.handleClose}
                appbar
                maxWidth="xs"
                secondaryAction={
                    <IconButton
                        aria-label="download"
                        onClick={this.onImageDownload}
                        size="large"
                        color="primary"
                    >
                        <CloudDownloadRounded />
                    </IconButton>
                }
                appBar
                // maxWidth="md"
            >
                <Box p={1} id="section-to-print">
                    <Box style={{ border: "1px solid #f0f0f0", borderRadius: "5px", textAlign: "center"}}>
                        {this.props.product ?
                            <Box style={{ alignItems: "center", justifyContent: "center"}}>
                            {/* <Box style={{ display: "flex", alignItems: "center", justifyContent: "center"}}> */}
                                <Box  p={1}>
                                    <QRCode
                                        size={256}
                                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                        value={`https://myjoulebox.com:8000/product/${this.props.product.id}`}
                                        viewBox={`0 0 256 256`}
                                        id="QRCode"
                                    />
                                </Box>
                                <Box p={1} >
                                    <Typography variant="h4">{this.props.product.ref}</Typography>
                                </Box>
                            </Box>
                            
                        :
                            <Box style={{ alignItems: "center", justifyContent: "center"}}>
                            {/* <Box style={{ display: "flex", alignItems: "center", justifyContent: "center"}}> */}
                                <Box  p={1}>
                                    <QRCode
                                        size={256}
                                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                        value={this.props.qrID}
                                        viewBox={`0 0 256 256`}
                                        id="QRCode"
                                    />
                                </Box>
                                <Box p={1} >
                                    <Typography variant="h4">{this.props.qrRef}</Typography>
                                </Box>
                            </Box>
                            
                        }
                    </Box>
                </Box>
            </PopUp>
        );
    }
}

export default GenerateQrCode;